<template>
  <div class="sweet-gt-captcha">
    <div class="sweet-gt-captcha__btn" :style="{ width: width }" id="captcha" ref="captcha">
    </div>
    <div class="loading" :style="{ width: width }" v-if="loading">
      <span class="loading--dot"></span>
      <span class="loading--dot"></span>
      <span class="loading--dot"></span>
      <span class="loading--dot"></span>
    </div>
    <div class="sweet-gt-captcha__error" :style="{ width: width }" v-if="error">
      <p>{{ filterLangText('init_error') }}, <a href="javascript:;" @click="init">{{ filterLangText('refresh') }}</a></p>
    </div>
  </div>
</template>
<style lang="css" src="./style/index.css"></style>
<script>
import langs from './captcha-lang.json'
import './lib/gt.js'
import axios from 'axios'
import props from './props'

export default {
  name: 'sweet-gt-captcha',
  data() {
    return {
      geetest: {
        'geetest_challenge': '',
        'geetest_validate': '',
        'geetest_seccode': ''
      },
      geetestObject: null,
      validate: false,
      loading: true,
      error: false,
      defaultHttps: false,
      errorsObject: {
        code: 'error',
        message: this.filterLangText('init_error') // '验证初始化失败'
      }
    }
  },
  props,
  mounted() {
    this.init()
  },
  watch: {
    formData: {
      handler() {
        if (this.validate) {
          this.resetCaptcha()
        }
      },
      deep: true
    }
  },
  methods: {
    /**
     * 获取相应的前端国际化文案
     * @param {String} 所需要文案的key
     * @returns {String} 文案
     */
    filterLangText(key) {
      if (langs[key]) {
        if (langs[key][this.lang]) {
          return langs[key][this.lang]
        }
        return langs[key]['zh-cn']
      }
      return ''
    },
    /**
     * 处理极验证的基础配置
     * @returns {Object} 配置对象
     */
    baseConfig() {
      let config = {
        product: this.product,
        width: this.width,
        lang: this.lang,
        https: this.defaultHttps, // 这边暂时以极验证后端服务支持的协议为准，props的https参数v1.0.6版本无效
        timeout: this.timeout
      }
      if (this.product === 'custom') {
        if (!this.area) {
          console.log('area缺失,product值为custom时,极验证的初始化参数area必须配置')
          return null
        }
        config = Object.assign({}, config, {
          area: this.area,
          next_width: this.next_width,
          bg_color: this.bg_color
        })
      }
      return config
    },
    /**
     * 初始化极验证
     */
    init() {
      this.getConfig()
        .then(this.onReadyCaptcha)
        .then(this.onSuccess)
    },
    /**
     * 获取初始化极验证所需的相关配置参数
     * @returns {Promise} promise实例
     */
    getConfig() {
      return new Promise((resolve, reject) => {
        if (!this.geetestObject) {
          this.error = false
          this.loading = true
          axios.get(this.action + '?v=' + new Date().getTime()).then((res) => {
            // 只要成功响应就默认可以初始化极验证
            if (res.status === 200) {
            // if (res.status === 200 && res.data.code === 'success') {
              const { data } = res.data
              const { static_severs } = data
              const isArray = (static_severs && static_severs instanceof Array && static_severs.length > 0)
              this.defaultHttps = isArray ? /^(https).+/g.test(static_severs[0]) : false
              resolve(res.data)
            } else {
              console.log(this.filterLangText('init_config_error'))
              this._reject(reject)
            }
          }).catch(() => {
            console.log(this.filterLangText('init_config_error'))
            this._reject(reject)
          })
        }
      })
    },
    /**
     * 初始化极验证，生成极验证对象
     * @param {Object} res 极验证所需的从服务器端拿取的相关配置参数
     * @returns {Promise} promise实例
     */
    onReadyCaptcha(res) {
      const vm = this
      return new Promise((resolve, reject) => {
        let { data } = res
        if (typeof data === 'string') data = JSON.parse(data)
        const baseConfig = this.baseConfig()
        const initGeetest = window.initGeetest
        if (initGeetest) {
          initGeetest({
            ...data.data,
            ...baseConfig
          }, (Geetest) => {
            this.geetestObject = Geetest
            Geetest.appendTo(vm.$refs.captcha)
            Geetest.onReady(() => {
              this.loading = false
              resolve(Geetest)
            })
            this.onError()
            this.onClose()
          })
        } else {
          console.log('initGeetest方法不存在')
          this._reject(reject)
        }
      })
    },
    _reject(reject) {
      this.error = true
      this.loading = false
      reject(this.errorsObject)
    },
    /**
     * 获取极验证后的结果
     * @returns {Boolean|Object} 校验结果
     */
    getValidate() {
      if (this.geetestObject) return this.geetestObject.getValidate()
      return false
    },
    /**
     * 当product为bind类型时，手动调用的极验证校验方法
     */
    verify() {
      if (this.geetestObject) this.geetestObject.verify()
    },
    /**
     * 重置极验证
     */
    reset() {
      if (this.geetestObject) this.geetestObject.reset()
    },
    /**
     * 极验证验证出错
     * @returns {Promise} promise实例
     */
    onError() {
      return new Promise((resolve) => {
        if (this.geetestObject) {
          this.geetestObject.onError((res) => {
            this.$emit('onError', res)
            resolve()
          })
        } else {
          resolve()
        }
      })
    },
    /**
     * 极验证关闭
     * @returns {Promise} promise实例
     */
    onClose() {
      return new Promise((resolve) => {
        if (this.geetestObject) {
          this.geetestObject.onClose((res) => {
            this.$emit('onClose', res)
            resolve()
          })
        } else {
          resolve()
        }
      })
    },
    /**
     * 极验证验证成功
     * @returns {Promise} promise实例
     */
    onSuccess() {
      return new Promise((resolve) => {
        if (this.geetestObject) {
          this.geetestObject.onSuccess(() => {
            const result = this.geetestObject.getValidate()
            if (result) {
              this.validate = true
              this.geetest = result
            } else {
              this.validate = false
              this.geetest = {
                'geetest_challenge': '',
                'geetest_validate': '',
                'geetest_seccode': ''
              }
            }
            this.$emit('onSuccess', {
              result: this.geetest,
              validate: this.validate
            })
            resolve()
          })
        } else {
          resolve()
        }
      })
    },
    /**
     * 重置校验
     */
    resetCaptcha() {
      this.geetest = {
        'geetest_challenge': '',
        'geetest_validate': '',
        'geetest_seccode': ''
      }
      this.validate = false
      this.reset()
      this.$emit('onReset', {
        result: this.geetest,
        validate: this.validate
      })
    },
    /**
     * 注销极验证
     */
    uninit() {
      this.resetCaptcha()
      this.geetestObject = null
    }
  },
  destroyed() {
    this.uninit()
  }
}
</script>
